export default {
  lang: '英語',
  homeScreen: {
    title: 'あなたの夢に推進力を',
    stayConnected: 'つながりを維持しましょう:',
    download: 'ダウンロード中',
  },
  notification: {
    newAndNow: '新着＆注目！',
    alert: '警告',
    message: 'メッセージ',
    contest: 'コンテスト',
    badge: '新しいバッジ',
    'content-update': 'コンテンツ更新',
    events: 'イベント',
  },
  loginScreen: {
    version2: {
      homeTitle:
        '私たちのシステムで、あなたの既存のプロフィールが見つかるか確認してみましょう。',
      homeTitleSub:
        'トレーニングプログラムへのログインに通常使用するメールアドレスを入力してください。',
      noAccount:
        'アカウントが見つかりません({email})。別のメールアドレスで試すか、今すぐアカウントを作成してください。',
      continueButton: '続ける',
      success:
        'アカウントの更新に成功しました！まもなくホームページに移動します。',
      successNewAccount:
        '登録を完了するには、アカウントを確認するための確認メールが送信されます。',
      loginButton: 'ログイン',
      matchFound:
        '一致する情報が見つかりました。パスワードを入力して次に進んでください。',
      magicLink: 'Eメールのリンクからログインしてください：',
      magicLinkButton: 'マジックリンクのリクエスト',
      magicLinkTitle:
        'あなたのEメールに直接リンクが送られ、すぐにサインインできます。',
      otherEmailButton: '投稿する',
      title:
        'あなたの個人プロフィールと連絡先情報が入力されますので、以下のすべての情報を入力してください。',
      titleIndustry:
        'あなたの個人プロフィールと連絡先情報が入力されますので、以下のすべての情報を入力してください。',
      register: 'アカウントの作成',
      agent: 'トラベル・アドバイザー',
      visitor: '業界ビジター',
      step1: 'ステップ1：ユーザーのタイプ',
      step2: 'ステップ 2: アカウントの作成',
      step3: 'ステップ3：プロフィールの作成',
      marketingOptIn:
        'このプログラムのトラベル・トレード・チームとのつながりを維持することに興味はありませんか？',
      optIn: 'はい、興味があります',
      optOut: '興味なし',
      step2Sub1: 'あなた自身について教えてください',
      step2Sub2: 'あなたのビジネスについて教えてください',
      privacyHead: '通信設定',
      privacySub:
        '以下のボックスにチェックを入れると、サプライヤーの旅行業界チームからの重要な連絡（商品の最新情報やお知らせ、特典、インセンティブ、FAMなど）や、TravPRO Mobileからの旅行業界ネットワーキングや営業支援イニシアチブを確実に受け取ることができます。',
      privacy:
        '当社はお客様のプライバシーを保護し、お客様の信頼を売り渡したり、悪用したり、裏切ったりすることは決してありません。',
      store: 'アプリストアで簡単にダウンロードできます：',
      powered: 'パワー・バイ',
      toastMessage: {
        forgotSuccess:
          'パスワードリセットリンクをEメールで送信しました！10秒後にログインページにリダイレクトされます。',
        emailNotExisting: '入力されたEメールアドレスが存在しません。',
        magicLinkMessage:
          '今、サインインしているところですので、お待ちください。',
        magicLinkError:
          'データベースにお客様のアカウントが見つかりませんでした。手動でログインしてください。10秒後にリダイレクトされます。',
        magicLinkError1:
          '有効なトークンが見つかりませんでした。ログインするか、新しいマジックリンクをリクエストしてください。この問題が解決しない場合は、info@travpromobile.com。',
        magicLinkError2:
          'データベースにお客様のアカウントが見つかりませんでした。手動でログインしてください。10秒後にリダイレクトされます。',
        magicLinkSuccess:
          'email}でメールをチェックしてください。魔法のリンクでサインインできます。',
        magicLinkErrorWait:
          'マジックリンクリクエストの間は5分間お待ちください。',
        emailNotFoundError:
          '入力されたメールアドレスが当社の記録にありません。スペルミスをチェックするか、アカウントを作成してください。',
      },
      errors: {
        zipCodeNotFound: '郵便番号が見つかりません。',
        zipCodeOnlyNumbers: 'ZipCode には数字のみを含めることができます。',
        password: 'パスワードを入力してください',
        passwordNotMatching: '入力したパスワードが一致しません。',
        passwordTooShort: 'パスワードは8文字以上',
        emailExists:
          'このメールアドレスは既に存在するか、無効です。別のメールアドレスで試すか、アカウントにログインしてください。',
        fillInAllFields: '必須項目をすべてご記入ください。',
        fillInEmail: 'Eメールをご記入ください。',
        emailNotExisting: '入力されたEメールアドレスが存在しません。',
      },
      fields: {
        forgotSubCopy: 'パスワードをお忘れですか？',
        forgotSubCopy2:
          'パスワードを完全に回避したいですか？自動的にプログラムにログインできる魔法のリンクをメールでお送りします。',
        city: '都市',
        companyName: '会社名',
        role: 'あなたの役割',
        description: '御社の事業内容を最もよく表しているのはどれですか？',
        country: '国名',
        password: 'パスワード',
        passwordRegister: 'パスワードの選択（最低8文字）',
        passwordConfirm: 'パスワードの確認',
        firstName: 'ファーストネーム',
        lastName: '姓（家族）',
        agency: '代理店名',
        title: 'あなたの役割（1つを選択）',
        company: '会社名',
        select: '以下のオプションを選択してください。',
        state: '州',
        province: '都道府県',
        zipCode: '郵便番号',
        postalCode: '郵便番号',
        affiliate: '主な所属事務所はどのグループですか？',
        hostAgency: 'ホスト・エージェンシー？',
        executive: 'エグゼクティブ',
        management: 'マネジメント',
        marketing: 'マーケティング',
        sales: '売上高',
        coordinator: 'コーディネーター',
        opt: 'このプログラムのトラベル・トレード・チームと連絡を取り合い、最新情報を受け取る。',
        optMarketing:
          '同様のプログラムやイベントに関して、TravPROと連絡を取り合ってください。',
        retail: '店舗フロント',
        home: '在宅エージェント',
        independent: 'インディペンデント・コントラクター',
        host: 'ホスト・エージェンシー',
        call: 'コールセンターまたはウェブベースの代理店',
        other: 'その他',
        describes:
          'あなたやあなたの代理店の事業を最もよく表しているものは何ですか？',
      },
    },
    title: '旅行の専門トレーニングと販売を可能にするプログラム',
    welcome: {
      headerTop: 'ようこそ',
      headerBottom: 'カリフォルニア STARセールスコンパニオンを見る ',
    },
    sellingPoints: [
      '毎日のセールス向上資料',
      '影響力の大きい発見 & プレゼンテーション',
      "'お気に入り'フォルダで自分に合わせて",
      'オンラインでもオフラインでも – いつでも, どこでも',
      'シェアし, つながり, 向上',
    ],
    emailPrompt:
      '旅行業界で働いていることを証明するため、あなたのEメールアドレスを入力してください。',
    tAndC: {
      agree: '続ける場合、以下に同意したものと見なします。 ',
      privacyPolicy: '当社のプライバシーポリシー',
      and: ' および ',
      termsConditions: '利用規約',
    },
    fields: {
      agency: '代理店',
      email: 'Eメール',
      firstName: '名前',
      lastName: '苗字',
      agencyName: '代理店名',
      stateProvince: '州 / 県',
      registrationCode: 'プロモーションコード（オプション）',
      required: '必須事項',
      invalidEmail: '無効なEメールアドレスです',
      opt: '連絡を取り合う！ はい、Visit Californiaからの通信をオプトインして、ニュース、イベント、インセンティブ、FAMなどに掲載されるようにします。',
      forgot:
        'パスワードをお忘れですか？下のボタンをクリックすると、パスワードをリセットするためのメールをお送りします。',
    },
    forgot: 'パスワードのリセット',
    noAgent: {
      noAgentButton: '私はアドバイザーではない',
      title: 'カリフォルニアSTARに興味を持っていただきありがとうございます。',
      messageWeb:
        '本サイトは旅行業界関係者だけを対象にしたコンテンツです。 \n カリフォルニアSTARについてさらに知りたい場合はこちらをご覧ください: ',
      messageMobile:
        'このアプリには旅行業関係者だけを対象にしたコンテンツが含まれています。でもこのアプリが何を提供するのか、’続行’を押してお気軽にプレビューをご覧ください。',
      continue: '続行',
      visitWebsite: 'ウェブサイトに行く >',
    },
    newUser: '新規ユーザ',
    register: '登録',
  },
  welcomeScreen: {
    title:
      'カリフォルニアSTARの\nトレーニングプログラムとセールスコンパニオン にようこそ',
    helloUser: 'こんにちは {name}',
    hello: 'こんにちは,',
    fromAgency: '{agency}から',
    notUser: '{name}ではありませんか?',
    introOnline:
      'オンラインで早速トレーニングを始めるか、コンテンツをプレインストールしていつもオフラインで使えるようにします!',
    introOffline:
      'すでに最新版がプレインストールされています。いつでもどこでもトレーニング、または販売開始です!',
    startTraining: 'トレーニング開始',
    downloader: {
      preload: 'プレインストール',
      stop: 'ストップ',
      init: '初期化中...',
      lastUpdate: '最終更新日: ',
    },
  },
  trainingScreens: {
    review: '顧みる',
    start: '開始',
    continue: '続行',
    welcome:
      '再設計されたトレーニングセクションへようこそ。 モジュールを完了するだけで、ゴールドCAスターになるという究極の目標に向けてポイントを獲得できます。 右側のバーには、あなたのやり方が正確に表示されます。',
    restart: '再起動',
    durationInMinutes: '{number} 分',
    percentageComplete: '{number}% 完了',
    unlock:
      'トレーニング第{number}章を完了すれば、この章をアンロックできます。',
    unlockSpecialization: '基礎を完了することでこの章を解除する',
    unlockSubtitle:
      'トレーニングの章を完了して、さらに多くの章をアンロックしましょう。',
    allUnlocked: 'すべての章をアンロックしました!',
    certificate: '証明書',
    courseComplete: 'コースを完了しました!',
    chapterComplete: '章が完了しました！',
    message: '{count} STARメッセージ',
    messagePlural: '{count} STARメッセージ',
    endReached: '最後に到達しました',
    retainEnd:
      'トップバーを使用してこの章を検索するか、戻るボタンを押して概要に戻ります。',
    watchListenRead: 'もっと見て, 聞いて & 読む',
    trouble: '手間取っているようですね。この設問をスキップしたいですか?',
    confirm: '回答を確認する',
    choose: '回答を選んでください',
    chapter: '章',
    essential: '必須課程',
    essentialSub:
      'ブロンズCA STARステータスを得るにはこれらの課程を履修してください。',
    specialization: '専門課程',
    specializationSub:
      'シルバーCA STARステータスを得るにはこれらの課程を履修してください。',
    status: '現在のステータス',
  },
  nav: {
    home: 'ホーム',
    train: 'トレーニング',
    retain: '維持する',
    directory: 'ディレクトリ',
    promote: '促進する',
    sell: '販売する',
    info: '情報',
    media: 'メディア',
    favorites: 'お気に入り',
    contact: '連絡先',
    reportCard: '成績表',
    accountSettings: 'アカウント設定',
    messages: 'STARメッセージ',
    search: '検索',
    showcases: '「ショーケース」、',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'トレーニング ライブラリ',
    retain: '保留',
    subapps: 'カリフォルニアパートナーミニモジュール',
    maintrainings: '財団',
    subtrainings: '経験',
  },
  pageDescriptions: {
    train: '教育し、関与し、専門家になる。',
    retain:
      '専門知識を保持し、営業活動を可能にするための頼りになるリソース。 この領域を使用して、製品に関する質問に専門的に回答したり、いつでも、どこでも、どのデバイスからでも、即席の販売プレゼンテーションとしても使用できます。',
    promote: 'シェア可能なセールス資料と連絡先情報へのアクセスが容易',
    sell: 'メディアファイルとセールス資料すべてをアクセスとシェアしやすいように整理',
    favorites: 'あなた個人のお気に入りコンテンツを確認',
    search: 'コンテンツすべてを閲覧する',
    subapps: '私達のパートナーからの詳細を学びなさい',
    maintrainings:
      'ディプロマを取得するには、これらの重要な章を完了する必要があります！',
    subtrainings: '以下の各専門的な経験を完了するとバッジを獲得できます。',
  },
  general: {
    showcase: 'Showcases',
    next: '次へ',
    previous: '前へ',
    submit: '送信',
    back: '戻る',
    close: '閉じる',
    page: 'ページ',
    search: '検索',
    logIn: 'ログイン',
    logOut: 'ログアウト',
    viewItem: '画面 {type}',
    imageNotFound: '画像が見つかりません',
    noResultsFor: ':の結果は見つかりませんでした{query}',
    noFavorites: 'まだお気に入りが設定されていません',
    noMessages: 'まだメッセージを受信していません!',
    resultsFor: ':の結果{query}',
    showAll: 'すべて表示',
    connectionError: '接続エラー',
    alreadyExists: 'すでに存在します',
    pageNotFound: '404 ページが見つかりません!',
    oops: 'え～、その...',
    overview: '概要に戻る',
    complete: 'コースを完了しました!',
    share: 'シェア',
    destinations: 'カリフォルニア パートナーのミニトレーニング',
    essentials: 'カリフォルニアの本質的要素',
    trainingLibrary: 'トレーニング ライブラリ',
    message: '{count} STARメッセージ',
    messagePlural: '{count} STARメッセージ',
    badge: 'バッジ',
  },
  itemTypes: {
    image: '画像',
    brochure: 'コレクション',
    layout: 'レイアウト',
    web: 'ウェブサイト',
    pdf: 'PDF',
    carousel: 'コレクション',
  },
  questions: {
    dials: '回答をマッチさせるため文字盤を回転させる',
    fitb: '空欄を埋める',
    flip: '回答をマッチさせるため番号を変更する',
    multipleChoice: '正しい回答を選んでください',
    slider: 'スクロール機能を使って正しい回答を選んでください',
    map: '地図の適切な位置をタップして正しい回答を選んでください',
    dropdown: '選択中...',
    true: '正しい',
    false: '間違い',
  },
  cookies: {
    consent: '同意する',
    optout: 'オプトアウト',
    settings: 'プライバシー設定',
    message:
      'あなたのデータプライバシー選択について何も指定されていません! それは大丈夫ですが、セールスコンパニオンを使用した最善の体験をご提供したいと思います。',
    disabled: 'クッキーの使用を無効にされているようですね。',
    use: '{appName}は最高の体験をお届けするため、クッキーの使用を求めています。',
    details: 'クッキーは何のために使われるのでしょうか?',
    enable: '{here}でクッキーを有効にする方法をご覧ください。',
    here: 'こちら',
  },
  notLoggedIn: {
    super: 'ログインしていません',
    title: 'このコンテンツを見るにはログインが必要です',
    guest: 'ゲスト',
  },
  demo: {
    message:
      'このウェブサイトは製品の最終版のデモになります。現在開発中の物で、完成品ではありません。',
    consent: '承知しました!',
  },
  share: {
    header: 'この資料をお気に入りのSNSでシェアしましょう!',
    download: 'ダウンロード',
  },
  breadCrumbs: {
    page: 'ページ',
  },
  onMobile: {
    header: 'モバイル端末からアプリストアへ、アクセスしようとしています。',
    body: '「カリフォルニア・スター」のプログラムをダウンロードするには、アプリストアで検索するか、下のどちらかのボタンを タップしてお進みください。',
    benefits: {
      header: 'このアプリをダウンロードすると：',
      1: '持ち運びが楽',
      2: 'WiFiの環境がなくても、いつでもどこでもトレーニングできます',
      3: '販促ツールや情報をいつでも参照できます',
    },
  },
  sharing: {
    twitter: 'カリフォルニアで次の休暇を過ごすことを考えてみましょう…',
    imageEmailSubject:
      'カリフォルニアSTARから、あなただけに...バケーションプラン',
    imageEmailCopy:
      'ちょっと時間を取って添付したカリフォルニアSTARの休暇コンテンツを確認しましょう… お楽しみください!',
    videoEmailSubject:
      'クールなカリフォルニアSTARバケーションプランがシェアされました!',
    videoEmailCopy:
      'このカリフォルニアSTARのバケーション動画をお楽しみいただけると思います。以下のリンクをクリックするだけでご覧いただけます。  お楽しみください!',
    infographicEmailSubject:
      'カリフォルニアSTARの休暇プランについてシェアしてください...',
    infographicEmailCopy:
      'こちらの関心がおありだと思いましたので、少し時間を取って添付したコンテンツをご覧ください。   是非またお会いしましょう!',
    copyURL: 'リンクをコピーする',
    copied: 'コピー',
  },
  newTrainingFlow: {
    tip: '秘訣: ‘それぞれの段階で課程を修了すれば ステータスが上がります。 夢は大きくゴールドCA STARステータスを得るには すべての課程を修了してください!',
    essentialModules: '必須課程',
    finishBronze:
      'ブロンズCA STARステータスを得るにはこれらの課程を履修してください。',
    specializationModules: '専門課程',
    finishSilver:
      'シルバーCA STARステータスを得るにはこれらの課程を履修してください。',
    partnerModules: 'パートナー課程',
    finishGold:
      'ゴールドCA STARステータスを得るにはこれらの課程を履修してください。',
    currentStatus: '現在のステータス',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: '{rank} ランキングに到達するまで!',
    outOf: '{points}  XPが不足しています',
    pointsToRank: '{pointsToLevel} ランクにはXPが必要です:  ({rank})',
  },
  points: {
    completed: '{completed} / {total} 完了',
  },
  new: {
    achievements: '成果',
  },
  badgeView: {
    title: 'トレーニング実績',
    subtitle:
      '達成ダッシュボードへようこそ！ここでは、ディプロマやスペシャリゼーションバッジの確認、追跡、ダウンロードができます。',
    badgeDisplayTitle: 'メタリック達成ステータス',
    badgeAchievement:
      'あなたは{rank｝ ステータスです！右のアイコンをクリックすると、ステータスを確認・共有できます。',
    bronze: 'ブロンズ',
    silver: 'シルバー',
    gold: 'ゴールド',
    platinum: 'プラチナ',
    complete: 'コンプリート',
    diploma: 'ディプロマ',
    chapterBadges: '専門バッジ',
    partnerBadges: 'パートナーバッジ',
  },
  badgeDisplay: {
    status: 'トレーニング達成状況',
  },
  search: {
    pages: 'ページ',
    resources: 'リソース',
  },
};
